// extracted by mini-css-extract-plugin
export default {"container":"MnsFf","content":"MzVrQ"};